// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1RzAy","title":"AfterFrontImage_title__2Gcvk"};